import React from 'react'
import ReactDOM from 'react-dom/client'

import Destinations from '../destinations/destinations'
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
  if ($('#destinations').length) {
    const $destinations = $('#destinations')

    const region = $destinations.data('region-id')
    const experience = $destinations.data('experience')
    const guest = $destinations.data('guest')
    const prefsEmpty = $destinations.data('prefs-empty')

    const root = ReactDOM.createRoot($destinations[0]);

    root.render(
      <Destinations initialRegion={region} initialExperience={experience} guest={guest} promptUpdatePrefs={prefsEmpty} />
    )
  }
})